import { Typography } from "@mui/material";
import { VAPID_KEY, messaging } from "api/firebase";
import { saveToken } from "api/services/notifications";
import { getToken, onMessage } from "firebase/messaging";
import { useEffect } from "react";
import { Slide, toast } from "react-toastify";

function useNotifications() {
  const content = (title: string, body: string) => (
    <>
      <Typography variant="body1">{title}</Typography>
      <Typography variant="body2">{body}</Typography>
    </>
  );

  useEffect(() => {
    const initializeMessaging = async () => {
      if (!localStorage.getItem("token")) return;

      try {
        const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");
        console.log("🟢 Service Worker Registered!", registration);

        if (Notification.permission === "default") {
          const permission = await Notification.requestPermission();
          console.log("🧪 Notification permission result:", permission);
          if (permission !== "granted") {
            throw new Error("Notification permission not granted");
          }
        } else if (Notification.permission === "denied") {
          // toast.warn(content("Notifications blocked", 
          //   "❌ Please enable them in your browser settings."), {
          //   position: "top-center",
          //   transition: Slide,
          // });
          return;
        }

        const token = await getToken(messaging, {
          vapidKey: VAPID_KEY,
          serviceWorkerRegistration: registration,
        });

        console.log("🟢 FCM Token:", token);
        await saveToken({ token });
      } catch (err) {
        console.error("🔴 Messaging setup failed:", err);
      }
    };

    initializeMessaging();

    // Foreground messages
    const unsubscribe = onMessage(messaging, (payload: any) => {
      const { title, body } = payload.notification;

      // ✅ Show native browser notification
      if (Notification.permission === "granted") {
        new Notification(title, {
          body: body,
          icon: "https://vider.in/images/vider-favicon.png", // Customize icon
        });
      }
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return null;
}

export default useNotifications;
